import { Types } from "../actions/PoolActions";

const initialState = {
    poolById: {},
    areas: {},
    maintenanceTypes: {},
    breakDownReasonGroups: {},
    poolRelationsById: {},
    editedPoolRelation: {},
    breakdownReasonPlaceData: [],
};

export const poolReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_POOL_BY_ID:
            return {
                ...state,
                poolById: action.payload || state.poolById,
            };
        case Types.SET_AREA_FOR_POOL:
            return {
                ...state,
                poolById: undefined,
                areas: action.payload || state.areas,
            };
        case Types.SET_MAINTENANCE_TYPE_LIST:
            return {
                ...state,
                areas: undefined,
                maintenanceTypes: action.payload || state.maintenanceTypes,
            };
        case Types.SET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL:
            return {
                ...state,
                maintenanceTypes: undefined,
                breakDownReasonGroups: action.payload || state.breakDownReasonGroups,
            };
        case Types.SET_POOL_RELATION_BY_ID:
            return {
                ...state,
                breakDownReasonGroups: undefined,
                poolRelationsById: action.payload || state.poolRelationsById,
            };
        case Types.EDIT_POOL_RELATION_RES:
            return {
                ...state,
                editedPoolRelation: action.payload || state.editedPoolRelation,
            };
        case Types.SET_BREAKDOWN_REASON_PLACE_DATA:
            return {
                ...state,
                breakdownReasonPlaceData: action.payload || [],
            };
        case Types.RESET_EDIT_POOL_RELATION_RES:
            return {
                ...state,
                editedPoolRelation: {},
            };

        default:
            return state;
    }
};
